import React from 'react'
import { BasicStatsItem } from '../index.styles'

const link = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQJxqslz_MM40ulib_VENvMeNJDu0gDoTtL5oFlPljTOxJ3dlOrSaUD1cvC5v4I7X0xzjl5Abqt1HWq/pubhtml?gid=0&single=true&widget=true&headers=false'

const PsdTables = () => {
  return (
    <BasicStatsItem style={{
      width: '100%',
      height: '100%',
    }}>
      <iframe title="PSD iframe" src={link} />
    </BasicStatsItem>
  )
}

export default PsdTables